import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/home/sect-2.webp")